<!-- PWA Update Notification -->
<div 
  *ngIf="showUpdatePrompt" 
  class="fixed top-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-slide-down"
  role="alert"
  aria-live="polite"
>
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-2xl border-l-4 border-blue-500 overflow-hidden">
    <div class="p-4">
      <div class="flex items-start">
        <!-- Icon -->
        <div class="flex-shrink-0">
          <div class="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center">
            <svg class="w-6 h-6 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
          </div>
        </div>

        <!-- Content -->
        <div class="ml-3 flex-1">
          <h3 class="text-sm font-semibold text-gray-900 dark:text-white">
            New Version Available!
          </h3>
          <p class="mt-1 text-sm text-gray-600 dark:text-gray-300">
            A new version of {{ companyName }} is ready. Update now for the latest features and improvements.
          </p>
          
          <!-- Buttons -->
          <div class="mt-3 flex gap-2">
            <button
              (click)="update()"
              class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 flex items-center space-x-2"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
              <span>Update Now</span>
            </button>
            <button
              (click)="dismiss()"
              class="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 text-sm font-medium rounded-lg transition-colors duration-200"
            >
              Later
            </button>
          </div>
        </div>

        <!-- Close button -->
        <div class="ml-4 flex-shrink-0">
          <button
            (click)="dismiss()"
            class="inline-flex text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
            aria-label="Close update notification"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>











